module.exports = __webpack_public_path__ + "img/course-11.dfd61323.png";